import { FormValues, getFormValues, isEmail, isPhoneNumber, isValidKennitala } from 'helpers';

export function getNetbankFormValues(applicantIsOnlyUser = true) {
	const form = document.querySelector('form');
	return form ? { ...getFormValues(form), applicantIsOnlyUser } : {};
}

export function getNetbankFormErrors(values: any) {
	return values.applicantIsOnlyUser ? {} : validateNetbankForm(values);
}

export const validators = {
	keyUserSsn: (value: string) => (isValidKennitala(value) ? {} : { keyUserSsn: 'error_wrong_ssn_length' }),
	keyUserEmail: (value: string) => (isEmail(value) ? {} : { keyUserEmail: 'error_email' }),
	keyUserPhone: (value: string) => (isPhoneNumber(value) ? {} : { keyUserPhone: 'error_phone_number' }),
	supervisorSsn: (value: string) => (isValidKennitala(value) ? {} : { supervisorSsn: 'error_wrong_ssn_length' }),
	supervisorEmail: (value: string) => (isEmail(value) ? {} : { supervisorEmail: 'error_email' })
};

export function validateNetbankForm(values: any) {
	return values.applicantIsOnlyUser
		? {}
		: Object.keys(validators).reduce((err, key) => {
				const validator = (validators as any)[key];
				const value = values[key];
				return { ...err, ...validator(value) };
			}, {} as any);
}

export function buildNetbankPayload(values: FormValues, ssn: string) {
	return {
		ssn,
		corporateUsers: {
			masterUser: {
				kennitala: values.keyUserSsn,
				email: values.keyUserEmail,
				phoneNumber: values.keyUserPhone
			},
			auditUser: {
				kennitala: values.supervisorSsn,
				email: values.supervisorEmail
			}
		}
	};
}
